import { z } from 'zod';

export const createCommentInputSchema = z.object({
  bodyMarkdown: z.string().trim().min(1).max(20_000),
});
export type CreateCommentInput = z.infer<typeof createCommentInputSchema>;

export const updateCommentInputSchema = z.object({
  bodyMarkdown: z.string().trim().min(1).max(20_000),
});
export type UpdateCommentInput = z.infer<typeof updateCommentInputSchema>;

export const toggleReactionInputSchema = z.object({
  emoji: z.enum([':+1:', ':-1:', ':tada:', ':eyes:']),
});
export type ToggleReactionInput = z.infer<typeof toggleReactionInputSchema>;
